import { initPublicHomeMarketing } from './marketing';
import { initPublicHomeUpload } from './upload';

const csrfToken = document.querySelector('#data-csrf-token')?.textContent?.trim() || '';

initPublicHomeMarketing();
initPublicHomeUpload({ csrfToken });
